<template>
  <div class="mb-1">
    <label :for="inputId" class="font-semibold text-xxs" :class="`color-${labelColor}`">
      {{ inputLabel }}
      <span v-if="isMandatory" class="color-danger">*</span>
    </label>
  </div>
</template>
<script lang="ts">
import { ComponentSizeType } from "@/types/componentType";
import { PropType, defineComponent } from "vue";

export default defineComponent({
  name: "CustomIonLabel",
  props: {
    inputLabel: { type: String, required: true },
    inputId: { type: String, required: true },
    labelColor: { type: String, default: "text" },
    isMandatory: { type: Boolean, default: false },
    size: { type: String as PropType<ComponentSizeType>, default: "default" },
  },
});
</script>
